var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 122 122",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m84.346 61.753-33.89 19.566V42.187l33.89 19.566Z",
  fill: "#fff"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 61,
  r: 60.5,
  stroke: "#fff"
})));
export default SvgPlay;